// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

// import vuetify from '@/plugins/vuetify' // path to vuetify export
// import './plugins/vuetify'

/**
 *  Module Vuetify qui permet la création de nos éléments HTML
 *  gère les actions avec VueJS et le design avec Material Design Lite
 */
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

/**
 * Module gérant la scrollbar
 */
import Vuebar from 'vuebar'

/**
 * Module pour la traduction de l'application
 */
import i18n from './translation'

/**
 * Module pour la validation des formulaires
 */
import validator from './validator'

/**
 * Module pour l'utilisation des cookies
 */
import cookie from 'vue-cookie'

/**
 * Module des filtres de l'application
 */
import filters from './filters'

/**
 * Modules pour les graphiques
 */
import VueHighcharts from 'vue-highcharts'
import Highcharts from 'highcharts'
import loadExporting from 'highcharts/modules/exporting'
import highchartsMore from 'highcharts/highcharts-more'
import solidGauge from 'highcharts/modules/solid-gauge'
import xrange from 'highcharts/modules/xrange-series'

/**
 *  Composants VueJS
 *  - ajax : sert aux requêtes Ajax mais aussi à utilisation d'interceptors (abort de Ajax, loading lors des Ajax...)
 *  - router : sert pour le routing et l'affichage des vues, chargement asynchrone de composant...
 *  - store : sert à stocker le state général de l'application, comme le fait que le l'utilisateur soit loggué ou non
 */
import axios from './ajax'
import { sync } from 'vuex-router-sync'
import store from './store'
import router from './router'

/**
 * Module vers l'API TF
 */
// import tfApi from 'tfapi-client'

/**
 *  importe le socket
 */
import WebSocketPlugin from '@/plugins/socket'
Vue.use(WebSocketPlugin, { store })

/**
 *  Point d'entrée de l'application
 */
import App from './App'

/**
 *  Composants Watcheezy
 */
import WzAvatar from './components/watcheezy/WzAvatar'
import WzAvatarDouble from './components/watcheezy/WzAvatarDouble'
import WzMenu from './components/watcheezy/WzMenu'
import WzAgentStatus from './components/watcheezy/WzAgentStatus'
import WzPupitreStatus from './components/watcheezy/WzPupitreStatus'
import WzNotifications from './components/watcheezy/WzNotifications' // système de notifications (arrivée des messages...)
import WzAgentMenu from './components/watcheezy/WzAgentMenu' // menu perso de l'agent (modif, log out...)
import WzSwitchLang from './components/watcheezy/WzSwitchLang'
import WzBiblio from './components/watcheezy/WzBiblio'
import WzRayon from './components/watcheezy/WzRayon'
import WzSentence from './components/watcheezy/WzSentence'
import WzProduct from './components/watcheezy/WzProduct'
import WzFaq from './components/watcheezy/WzFaq'
import WzIntent from './components/watcheezy/WzIntent'
import WzEntity from './components/watcheezy/WzEntity'
import WzLearn from './components/watcheezy/WzLearn'
import WzNewIntent from './components/watcheezy/WzNewIntent'
import WzHistoChats from './components/watcheezy/WzHistoChats'
import WzHistoBot from './components/watcheezy/WzHistoBot'
import WzConvTrainingBot from './components/watcheezy/WzConvTrainingBot'
import WzFileSelector from './components/watcheezy/WzFileSelector'
import WzImgUpload from './components/watcheezy/WzImgUpload'
import WzSelectAgents from './components/watcheezy/WzSelectAgents'
import WzSelectAgent from './components/watcheezy/WzSelectAgent'
import WzSelectBots from './components/watcheezy/WzSelectBots'
import WzSelectMotifs from './components/watcheezy/WzSelectMotifs'
import WzSelectOneAgent from './components/watcheezy/WzSelectOneAgent'
import WzSelectOneSite from './components/watcheezy/WzSelectOneSite'
import WzSelectGender from './components/watcheezy/WzSelectGender'
import WzRating from './components/watcheezy/WzRating'
import WzHelp from './components/watcheezy/WzHelp'
import WzSatisfactionAgent from './components/watcheezy/WzSatisfactionAgent'
import WzNotifier from './components/watcheezy/WzNotifier'
import WzDialog from './components/watcheezy/WzDialog'
import WzEditeurLead from './components/watcheezy/WzEditeurLead'
import WzAgentsOccupationDay from './components/watcheezy/WzAgentsOccupationDay'
import WzAgentsOccupationPeriode from './components/watcheezy/WzAgentsOccupationPeriode'
import WzAgentsPresenceDay from './components/watcheezy/WzAgentsPresenceDay'
import WzDialogConfirm from './components/watcheezy/WzDialogConfirm'
import WzUpdateIntent from './components/watcheezy/WzUpdateIntent'
import WzNewQuestionIntent from './components/watcheezy/WzNewQuestionIntent'
import WzDeleteExempleIntent from './components/watcheezy/WzDeleteExempleIntent'
import WzNewFAQ from './components/watcheezy/WzNewFAQ'
import WzTxtEditor from './components/watcheezy/WzTxtEditor' // editor de text tynimce

// Composant pour le chat watcheebox et cobrowsing
import WzWatcheeboxVisiteur from './components/watcheebox/WzWatcheeboxVisiteur'
import WzWatcheeboxAgent from './components/watcheebox/WzWatcheeboxAgent'
import WzListAgents from './components/watcheebox/WzListAgents'
import WzCobrowsingClient from './components/watcheebox/WzCobrowsingClient'
import WzFenetreChat from './components/watcheebox/WzFenetreChat'
import WzViewChat from './components/watcheebox/WzViewChat'
import WzViewAttente from './components/watcheebox/WzViewAttente'
import WzVisiteurAttente from './components/watcheebox/WzVisiteurAttente'
import WzVisiteurTimer from './components/watcheebox/WzVisiteurTimer'
import WzContentInfosVisiteur from './components/watcheebox/WzContentInfosVisiteur'
import WzFicheInfosVisiteur from './components/watcheebox/WzFicheInfosVisiteur'
import WzFicheBiblioPhrases from './components/watcheebox/WzFicheBiblioPhrases'
import WzFichePushProduit from './components/watcheebox/WzFichePushProduit'
import WzFicheLeadVisiteur from './components/watcheebox/WzFicheLeadVisiteur'
import WzListChatsAgent from './components/watcheebox/WzListChatsAgent'

// Composant pour les DialogBox
import WzDialogCloseChat from './components/watcheebox/WzDialogCloseChat'
import WzDialogTransfertChat from './components/watcheebox/WzDialogTransfertChat'
import WzDialogBannishVisitor from './components/watcheebox/WzDialogBannishVisitor'
import WzDialogInfos from './components/watcheebox/WzDialogInfos'
import WzTimer from './components/watcheebox/WzTimer'
import WzCatalogueProduits from './components/watcheebox/WzCatalogueProduits'
import WzSearchVisitor from './components/watcheebox/WzSearchVisitor'

// dialog openAI
import WzDialogOpenAIKeywordProduct from './components/watcheezy/WzDialogOpenAIKeywordProduct'
import WzDialogOpenAIKeyword from './components/watcheezy/WzDialogOpenAIKeyword'
import WzDialogOpenAIFAQ from './components/watcheezy/WzDialogOpenAIFAQ'
import WzDialogImportPDF from './components/watcheezy/WzDialogImportPDF'
import WzDialogFileChunk from './components/watcheezy/WzDialogFileChunk'
import WzDialogFileResume from './components/watcheezy/WzDialogFileResume'
import WzDialogAnalyseChat from './components/watcheezy/WzDialogAnalyseChat'
import WzDialogAddUrls from './components/watcheezy/WzDialogAddUrls'
import WzDialogModifContentFile from './components/watcheezy/WzDialogModifContentFile'
import WzDialogEnhancePrompt from './components/watcheezy/WzDialogEnhancePrompt'
import WzDialogVersionPrompt from './components/watcheezy/WzDialogVersionPrompt'

// composant spécials
import WzMenuFreshdesk from './components/watcheezy/WzMenuFreshdesk'

/**
 * Mixins
 */
import permissions from './mixins/permissions'

/**
 * Import csv-import
 */
import { VueCsvImportPlugin } from 'vue-csv-import/src'
Vue.use(VueCsvImportPlugin)

/**
 * Import dropzone
 */
import vue2Dropzone from 'vue2-dropzone'
// import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import './assets/css/vue2Dropzone.css'
Vue.component('vue-dropzone', vue2Dropzone) // composant dropzone
/**
 * Utilisation de Vuetify par VueJS
 */
Vue.use(Vuetify, {
  theme: {
    primary: '#001B39', // couleur DRDE
    secondary: '#3CC0F0', // couleur DRDE
    accent: '#FF7617',
    tertiary: '#27C9D6',
    info: '#2196F3', // $blue.base
    warning: '#FFC107', // $amber.base
    error: '#F44336', // $red.base
    success: '#4CAF50', // $green.base
    btn: '#1461BD' // $green.base
  }
})
/*
const opts = {}

export default new Vuetify(opts)
*/
/**
 * Utilisation de la scrollbar
 */
Vue.use(Vuebar)

/**
 * Utilisation du module graphique
 */
loadExporting(Highcharts)
highchartsMore(Highcharts)
xrange(Highcharts)
solidGauge(Highcharts)
Vue.use(VueHighcharts, { Highcharts })

/**
 * Utilisation des composants par Vue
 */
Vue.component('wz-avatar', WzAvatar)
Vue.component('wz-avatar-double', WzAvatarDouble)
Vue.component('wz-menu', WzMenu)
Vue.component('wz-agent-status', WzAgentStatus)
Vue.component('wz-pupitre-status', WzPupitreStatus)
Vue.component('wz-notifications', WzNotifications)
Vue.component('wz-agent-menu', WzAgentMenu)
Vue.component('wz-switch-lang', WzSwitchLang)
Vue.component('wz-biblio', WzBiblio)
Vue.component('wz-rayon', WzRayon)
Vue.component('wz-faq', WzFaq)
Vue.component('wz-intent', WzIntent)
Vue.component('wz-entity', WzEntity)
Vue.component('wz-learn', WzLearn)
Vue.component('wz-new-intent', WzNewIntent)
Vue.component('wz-sentence', WzSentence)
Vue.component('wz-product', WzProduct)
Vue.component('wz-histo-chats', WzHistoChats)
Vue.component('wz-histo-bot', WzHistoBot)
Vue.component('wz-conv-training-bot', WzConvTrainingBot)
Vue.component('wz-file-selector', WzFileSelector)
Vue.component('wz-img-upload', WzImgUpload)
Vue.component('wz-select-agents', WzSelectAgents)
Vue.component('wz-select-agent', WzSelectAgent)
Vue.component('wz-select-bots', WzSelectBots)
Vue.component('wz-select-motifs', WzSelectMotifs)
Vue.component('wz-select-one-agent', WzSelectOneAgent)
Vue.component('wz-select-one-site', WzSelectOneSite)
Vue.component('wz-select-gender', WzSelectGender)
Vue.component('wz-rating', WzRating)
Vue.component('wz-help', WzHelp)
Vue.component('wz-satisfaction-agent', WzSatisfactionAgent)
Vue.component('wz-notifier', WzNotifier)
Vue.component('wz-dialog', WzDialog)
Vue.component('wz-editeur-lead', WzEditeurLead)
Vue.component('wz-agents-occupation-day', WzAgentsOccupationDay)
Vue.component('wz-agents-occupation-periode', WzAgentsOccupationPeriode)
Vue.component('wz-agents-presence-day', WzAgentsPresenceDay)
Vue.component('wz-editeur-lead', WzEditeurLead)
Vue.component('wz-txt-editor', WzTxtEditor) // editeur de text

/**
 * Utilisation des composants chat Watcheebox par Vue
 */
Vue.component('wz-watcheebox-visiteur', WzWatcheeboxVisiteur) // le visiteur
Vue.component('wz-watcheebox-agent', WzWatcheeboxAgent) // l'agent
Vue.component('wz-list-agents', WzListAgents) // la liste d'agent
Vue.component('wz-cobrowsing-client', WzCobrowsingClient) // la vu mirroring du visiteur
Vue.component('wz-fenetre-chat', WzFenetreChat) // la fenetre de chat
Vue.component('wz-view-chat', WzViewChat) // la vue visiteur avec chat cobrowsing etc....
Vue.component('wz-view-attente', WzViewAttente) // la vue file d'attente
Vue.component('wz-visiteur-attente', WzVisiteurAttente) // le visiteur dans la file d'attente
Vue.component('wz-visiteur-timer', WzVisiteurTimer) // le timer visiteur attente
Vue.component('wz-content-infos-visiteur', WzContentInfosVisiteur) // le contenu des infos visiteur
Vue.component('wz-fiche-infos-visiteur', WzFicheInfosVisiteur) // la fiche des infos visiteur
Vue.component('wz-fiche-biblio-phrases', WzFicheBiblioPhrases) // la fiche des phrases agent
Vue.component('wz-fiche-push-produit', WzFichePushProduit) // la fiche des phrases agent
Vue.component('wz-fiche-lead-visiteur', WzFicheLeadVisiteur) // la fiche du lead visiteur
Vue.component('wz-list-chats-agent', WzListChatsAgent) // la liste des chats de l'agent selectionné

Vue.component('wz-dialog-transfert-chat', WzDialogTransfertChat) // permet de transférer un chat vers un autre agent
Vue.component('wz-dialog-bannish-visitor', WzDialogBannishVisitor) // permet de bannir un visiteur
Vue.component('wz-dialog-close-chat', WzDialogCloseChat) // dialogbox fermeture d'un chat
Vue.component('wz-dialog-infos', WzDialogInfos) // ouvre une dialogBox pour afficher des infos type infobull
Vue.component('wz-timer', WzTimer) // un timer mini
Vue.component('wz-dialog-confirm', WzDialogConfirm) // dialogue de confirmation avant enregistrement
Vue.component('wz-update-intent', WzUpdateIntent) // dialogue de mise à jour d'une intention
Vue.component('wz-new-question-intent', WzNewQuestionIntent) // dialogue ajouter une question supplementaire a une intention
Vue.component('wz-delete-exemple-intent', WzDeleteExempleIntent) // dialogue pour supprimer un exemple a une intention
Vue.component('wz-new-faq', WzNewFAQ) // ajoute une nouvelle faq + intention
Vue.component('wz-catalogue-produits', WzCatalogueProduits) // catalogue de produits
Vue.component('wz-search-visitor', WzSearchVisitor) // recherche un visiteur

// openAI composant
Vue.component('wz-dialog-openai-keyword-product', WzDialogOpenAIKeywordProduct)
Vue.component('wz-dialog-openai-keyword', WzDialogOpenAIKeyword)
Vue.component('wz-dialog-openai-faq', WzDialogOpenAIFAQ)
Vue.component('wz-dialog-import-pdf', WzDialogImportPDF)
Vue.component('wz-dialog-file-chunk', WzDialogFileChunk)
Vue.component('wz-dialog-file-resume', WzDialogFileResume)
Vue.component('wz-dialog-analyse-chat', WzDialogAnalyseChat)
Vue.component('wz-dialog-add-urls', WzDialogAddUrls)
Vue.component('wz-dialog-modif-content-file', WzDialogModifContentFile)
Vue.component('wz-dialog-version-prompt', WzDialogVersionPrompt)
Vue.component('wz-dialog-enhance-prompt', WzDialogEnhancePrompt)

Vue.component('wz-menu-freshdesk', WzMenuFreshdesk) // menu special frshdesk

/**
 * Filtres
 */
for (const filter in filters) {
  if (filters.hasOwnProperty(filter)) {
    Vue.filter(filter, filters[filter])
  }
}

/**
 * Mixins
 */
Vue.mixin(permissions)

/**
 * Synchronisation entre le store et le router
 */
sync(store, router)

Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  axios,
  router,
  store,
  i18n,
  cookie,
  validator,
  template: '<App/>',
  // created () {
    // tfApi.init({
    //   env: process.env.NODE_ENV
    // })
  // },
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js